import { render } from "./PlannelHeader.vue?vue&type=template&id=70d47229&scoped=true"
import script from "./PlannelHeader.vue?vue&type=script&lang=js"
export * from "./PlannelHeader.vue?vue&type=script&lang=js"

import "./PlannelHeader.vue?vue&type=style&index=0&id=70d47229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d47229"]])

export default __exports__